/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { DeviceMeasurementErrorDto } from './DeviceMeasurementErrorDto';
import {
    DeviceMeasurementErrorDtoFromJSON,
    DeviceMeasurementErrorDtoFromJSONTyped,
    DeviceMeasurementErrorDtoToJSON,
} from './DeviceMeasurementErrorDto';

/**
 * 
 * @export
 * @interface PtwErrorExceptionDetails
 */
export interface PtwErrorExceptionDetails {
    /**
     * 
     * @type {DeviceMeasurementErrorDto}
     * @memberof PtwErrorExceptionDetails
     */
    error?: DeviceMeasurementErrorDto;
    /**
     * 
     * @type {string}
     * @memberof PtwErrorExceptionDetails
     */
    $type?: PtwErrorExceptionDetailsTypeEnum;
}


/**
 * @export
 */
export const PtwErrorExceptionDetailsTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoPtwErrorExceptionDetailsPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.PtwErrorExceptionDetails, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type PtwErrorExceptionDetailsTypeEnum = typeof PtwErrorExceptionDetailsTypeEnum[keyof typeof PtwErrorExceptionDetailsTypeEnum];


/**
 * Check if a given object implements the PtwErrorExceptionDetails interface.
 */
export function instanceOfPtwErrorExceptionDetails(value?: unknown): value is PtwErrorExceptionDetails {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(PtwErrorExceptionDetailsTypeEnum)[0];
}

export function PtwErrorExceptionDetailsFromJSON(json: any): PtwErrorExceptionDetails {
    return PtwErrorExceptionDetailsFromJSONTyped(json, false);
}

export function PtwErrorExceptionDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PtwErrorExceptionDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'error': !exists(json, 'error') ? undefined : DeviceMeasurementErrorDtoFromJSON(json['error']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function PtwErrorExceptionDetailsToJSON(value?: PtwErrorExceptionDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'error': DeviceMeasurementErrorDtoToJSON(value.error),
        '$type': value.$type,
    });
}

